module.exports = __webpack_public_path__ + "static/img/509.4f8ea259.jpg";